import $http from "../../axios"
import { Notification,  MessageBox } from 'element-ui'

export async function getDocuments({commit,state},requestParameters = {params: state.params}){
    await $http.get('/api/documents',requestParameters).then((res)=>{
        commit('setDocuments',res.data);
    }).catch((error)=>{
        Notification.error({
			title: '¡Error!',
			message: error.message,
			type: 'error',
			duration: 1500,
			customClass: 'notification-box'
		})
        commit('documentError', error.message)
    })
}
export async function getVouchersType({commit,state},parameter){
    await $http.get('/api/voucherstype',parameter).then((res)=>{
        commit('setVouchersType',res.data);
    }).catch((error)=>{
        Notification.error({
			title: '¡Error!',
			message: error.message,
			type: 'error',
			duration: 1500,
			customClass: 'notification-box'
		})
        commit('voucherTypeError', error.message)
    })
}
export async function getCategory({commit,state},requestParameters ={params: state.category}){
    await $http.get('/api/category',requestParameters).then((res)=>{
        commit('setCategory',res.data);
    }).catch((error)=>{
        Notification.error({
			title: '¡Error!',
			message: error.message,
			type: 'error',
			duration: 1500,
			customClass: 'notification-box'
		})
        commit('CategoryError', error.message)
    })
}

export async function uploadDocumentAttachmentFile({commit, state}, formData) {
    return new Promise((resolve, reject) => {
        $http.post('/api/document-attachment-files', formData).then((res) => {
            resolve(res.data);
        }).catch((error) => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            })
            reject(error);
        })
    })
}

export async function removeDocumentAttachmentFile({commit, state}, id) {
    return new Promise((resolve, reject) => {
        $http.delete(`/api/document-attachment-files/${id}`).then((res) => {
            resolve(res.data);
        }).catch((error) => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            })
            reject(error);
        })
    })
}

export async function getDocumentAttachmentFiles({commit, state}, documentId) {
    return new Promise((resolve, reject) => {
        $http.get(`/api/document-attachment-files/document/${documentId}`).then((res) => {
            resolve(res.data);
        }).catch((error) => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            })
            reject(error);
        })
    })
}

export async function searchDocumentForLocationsModule({commit, state}, params) {
    return new Promise((resolve, reject) => {
        $http.get('/api/buscar-documento-ubicaciones', { params }).then((res) => {
            resolve(res.data);
        }).catch((error) => {
            // Un 404 aquí es un resultado esperado (no se encontró documento),
            // no un error real del sistema - lo maneja el componente sin notificación.
            if (!error.response || error.response.status !== 404) {
                Notification.error({
                    title: '¡Error!',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                })
            }
            reject(error);
        })
    })
}

export async function getVoucherTypesLite({commit, state}, params) {
    return new Promise((resolve, reject) => {
        $http.get('/api/tipos-de-comprobantes-lite', { params }).then((res) => {
            resolve(res.data);
        }).catch((error) => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            })
            reject(error);
        })
    })
}
export async function updateInventoryLocation({commit, state}, params) {
    return new Promise((resolve, reject) => {
        $http.put('/api/actualizar-localizacion', params).then((res) => {
            resolve(res.data);
        }).catch((error) => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            })
            reject(error);
        })
    })
}


// WEBPACK FOOTER //
// ./src/modules/documents/actions.js